var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.167464 7.37142C-0.0553925 7.59428 -0.0553925 7.95599 0.167464 8.1797C0.39032 8.40342 0.752033 8.40256 0.975746 8.1797L0.167464 7.37142ZM4.00059 4.34658L4.4043 4.75029C4.62716 4.52744 4.62716 4.16572 4.4043 3.94201L4.00059 4.34658ZM0.975746 0.51431C0.75289 0.291454 0.391177 0.291454 0.167464 0.51431C-0.0562496 0.737166 -0.0553925 1.09888 0.167464 1.32259L0.975746 0.51431ZM0.975746 8.1797L4.4043 4.75029L3.59602 3.94287L0.167464 7.37142L0.975746 8.1797ZM4.4043 3.94287L0.975746 0.51431L0.167464 1.32259L3.59602 4.75115L4.4043 3.94287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/leftarrow.464bea8ff5143ac1d59118ee9f6576da.svg";
export { ForwardRef as ReactComponent };